import React from 'react';
import Moment from 'react-moment';

export const SafeMoment = (props:any) => {
  if([null, '', '0000-00-00 00:00:00'].includes(props.children)) {
    return <></>
  }
  return <Moment {...props}>{props.children}</Moment>
}
